import DetailViewContentElement from "../../detailView/elements/detailViewContentElement";
import {VerticalAlignment} from "../../../enums/verticalAlignment";

export default class Grid extends DetailViewContentElement {
  layout_config: Array<number>;
  vertical_alignment: VerticalAlignment;
  constructor() {
    super();
    this.defineProperty("vertical_alignment", 2);
    this.defineProperty("layout_config", [1,1]);
  }
  get isExpandable(){
    return true
  }
}